import React from 'react';
import { Translate } from 'react-jhipster';
import { Button, Modal, ModalBody, Row, ModalHeader, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';

export interface IShowMessageModalProps {
  showModal: boolean;
  message: string;
  handleClose: Function;
  handleSubmit: Function;
}

class ShowMessageModal extends React.Component<IShowMessageModalProps> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Modal id="modalUserExists" isOpen={this.props.showModal} backdrop="static" centered>
          <ModalHeader toggle={this.props.handleClose}>
            <h3 className="font-weight-bold">Thông Báo</h3>
          </ModalHeader>
          <ModalBody className="padding-modal-body">
            <Row style={{ padding: '20px' }}>
              <h5>
                <span>{this.props.message}</span>
              </h5>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-register" onClick={this.props.handleSubmit}>
              Thêm
            </Button>{' '}
            <Button className="btn-register-white" onClick={this.props.handleClose}>
              Bỏ qua
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ShowMessageModal;
